import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Avatar, Spinner } from '../ui'
import { ChatTranscript } from '../ChatTranscript'
import { formatRelative } from '../../lib/support'

export const ChatsTab = ({ chats, loading }) => {
  const [openId, setOpenId] = useState(null)

  if (loading) return <Spinner />
  if (chats.length === 0) return <p className="text-admin-600">Nenhuma conversa de suporte deste estúdio.</p>

  return (
    <section className="flex flex-col gap-2">
      {chats.map((c) => {
        const open = openId === c.id
        const who = c.user_name || c.user_email || 'Usuário desconhecido'
        const first = c.messages?.find((m) => m.role === 'user')?.content
        return (
          <div key={c.id} className="card flex flex-col overflow-hidden">
            <button
              type="button"
              onClick={() => setOpenId(open ? null : c.id)}
              aria-expanded={open}
              className="flex items-center gap-3 px-4 py-3 text-left"
            >
              <Avatar size={32} className="bg-primary-100 text-[13px] text-primary-800">
                {who[0].toUpperCase()}
              </Avatar>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="font-semibold">{who}</span>
                <span className="truncate text-xs text-admin-600">
                  {formatRelative(c.created_at)} · {c.message_count} mensagens{first ? ` · “${first}”` : ''}
                </span>
              </span>
              {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
            </button>
            {open && (
              <div className="flex flex-col gap-2 bg-admin-100 px-4 pb-4 pt-3">
                <ChatTranscript messages={c.messages || []} />
              </div>
            )}
          </div>
        )
      })}
    </section>
  )
}
